import HomeLink from "./HomeLink";
import PercentBar from "./PercentBar";
import TopBanner from "./TopBanner";
import CreditPanel from "./CreditPanel";

export default function MintBiznessmen() {
    // const navigate = useNavigate();
    const purchase = () => {
        console.log('purchasing...');
        // navigate('/purchase');
    }

    return (
        <div className="App-header">
            <div style={{width: '80%', minWidth: '750px'}}>
                <TopBanner />
            </div>
            <div className='flexRowTop' style={{width: '80%', minWidth: '750px', border: 'solid 2px grey', borderRadius: '10px', padding: '15px', marginBottom: '10px'}}>
                <div className='flexColumn' style={{width: '50%', minWidth: '350px', padding: '15px', gap: '15px'}}>
                    <div className='launchTitle'>The&nbsp;Biznessmen</div>
                    <div>
                        Welcome to an exciting world where you can game, stake and earn $BIZ from your own
                        unique Biznessmen NFT.
                    </div>
                    <div>
                        Will you make lucrative investments from The Corporation? Or will you make criminal
                        earnings by joining The Underworld.
                    </div>
                    <div>
                        Join the future of blockchain P2E gaming and make your Bizness the best in Biz City!
                    </div>
                    <div>
                        Supply: 3333 Biznessmen
                    </div>
                    <div className='flexRow' style={{gap: '5px'}}>
                        <div>Native coin:</div><div><img alt='BIZ' src='/4mint/bizcoin-32.png' style={{width: '25px', height: '25px', margin: '7px 0px 0px 5px'}}/></div><div>$BIZ</div>
                    </div>
                    <div className='flexRow' style={{marginTop: '5px'}}>
                        <a href='https://biznessmen-nft.gitbook.io/biznessmen/' target='project'><button className='linkButton'>Project</button></a>
                        <a href='https://discord.com/channels/908601406288724019/908606414853906442' target='discord'><button className='linkButton'>Discord</button></a>
                        <a href='https://biznessmen.netlify.app' target='game'><button className='linkButton'>Game</button></a>
                    </div>
                </div>

                <div className='flexColumn' style={{width: '50%', minWidth: '350px', padding: '15px'}}>
                    <img alt='' src='/4mint/biznessmen-1.png' width='100%' style={{borderRadius: '15px'}}/>
                    <div className='smallText' style={{width: '100%', display: 'flex'}}>
                        <div style={{width: '50%', textAlign: 'left'}}>WL Price: 0.75 SOL</div>
                        <div style={{width: '50%', textAlign: 'right'}}>Minted 33% (1 / 3)</div>
                    </div>
                    <div style={{width: '100%', alignItems: 'flex-end'}}><PercentBar percent={33}/></div>
                    <div className='flexRow' style={{marginTop: '5px'}}>
                        <button className='mintButton' style={{padding: '10px'}} onClick={purchase}>Mint</button>
                    </div>
                </div>
            </div>
            <CreditPanel />
            <HomeLink/>
        </div>
    )
}
